import { motion } from "framer-motion";

// Soft light-blue ambient glows for the white theme (no dark fills).
export const GradientBlobs = ({ className = "" }) => (
  <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
    <motion.div
      className="absolute -top-32 -left-24 w-[46rem] h-[46rem] rounded-full blur-[130px] opacity-40"
      style={{ background: "radial-gradient(circle at 30% 30%, #7CC4FF, transparent 70%)" }}
      animate={{ x: [0, 60, -20, 0], y: [0, -40, 30, 0], scale: [1, 1.15, 0.95, 1] }}
      transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
    />
    <motion.div
      className="absolute top-1/4 -right-24 w-[40rem] h-[40rem] rounded-full blur-[130px] opacity-30"
      style={{ background: "radial-gradient(circle at 50% 50%, #4FA9F5, transparent 70%)" }}
      animate={{ x: [0, -50, 20, 0], y: [0, 40, -30, 0], scale: [1, 0.9, 1.1, 1] }}
      transition={{ duration: 26, repeat: Infinity, ease: "easeInOut" }}
    />
    <motion.div
      className="absolute bottom-0 left-1/3 w-[38rem] h-[38rem] rounded-full blur-[130px] opacity-25"
      style={{ background: "radial-gradient(circle at 50% 50%, #2A8CF0, transparent 70%)" }}
      animate={{ x: [0, 40, -40, 0], y: [0, -20, 20, 0], scale: [1, 1.1, 0.9, 1] }}
      transition={{ duration: 30, repeat: Infinity, ease: "easeInOut" }}
    />
  </div>
);
